import React, {useEffect} from "react";
import {useModel} from "../../models";
import {useHistory, useLocation} from "react-router-dom";
import {getPageById, goPage} from "./pageDefinition";
import style from "./MainLayout.module.scss";
import {Tag} from "antd";

const AppNav = () => {
    const [{navTabs, navSelected}, {selectNav, closeNav}] = useModel("nav");

    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        const page = getPageById(navSelected)
        if (page) {
            //路由是否变化
            if (location.pathname !== page.path) {
                goPage(history, navSelected)
                // console.log("走这里")
            }
        }
    }, [navSelected]);

    return (
            <div className={style.navScroll}>
                <div className={style.nav}>
                    {navTabs.map(el => <Tag
                        style={{cursor: "pointer"}}
                        key={el.id}
                        color={el.id === navSelected ? "#2db7f5" : ""}
                        closable={el.closable}
                        onClick={() => selectNav(el.id)}
                        onClose={() => closeNav(el.id)}
                    >
                        {el.name}
                    </Tag>)}
                </div>
            </div>


    )
};

export default AppNav;